import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagSR = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.806 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M48.444 16.304H1.554A24.948 24.948 0 0 0 0 25c0 3.058.55 5.987 1.555 8.695h46.89A24.945 24.945 0 0 0 49.999 25c0-3.058-.55-5.988-1.555-8.696Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M25.072 50c8.563 0 16.12-4.306 20.625-10.87H4.448C8.954 45.695 16.51 50 25.072 50ZM25.072 0c8.563 0 16.12 4.306 20.625 10.87H4.448C8.954 4.306 16.51 0 25.072 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m25 16.304 2.158 6.643h6.985l-5.651 4.105 2.159 6.643L25 29.59l-5.651 4.105 2.158-6.643-5.65-4.105h6.984L25 16.304Z"
}));
FlagSR.displayName = 'FlagSR';
export default withFlagWrapper(FlagSR);
//# sourceMappingURL=index.js.map